import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import {
  removeLocaleFromHref,
  toLocalized,
  setActiveLocations,
  getAllLocations,
} from 'shared/helpers/locale';
import Link from 'shared/components/Link/Link';
import { compareByTitle } from 'shared/helpers/arrays';
import COUNTRIES from 'shared/constants/json/countries.json';

import s from './Footer.css';
import LINKS from '../../constants/navigation';
import LocationList from './LocationList/LocationList';

class Footer extends React.Component {
  static propTypes = {
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        slug: PropTypes.string,
      }),
    ),
    currentPath: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    seoSearchUrlResponse: PropTypes.shape(),
    hideLocations: PropTypes.bool,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    languages: [
      {
        title: 'рус',
        slug: 'ru',
      },
      {
        title: 'укр',
        slug: 'uk',
      },
    ],
    routeName: null,
    seoSearchUrlResponse: {},
    hideLocations: false,
  };

  render() {
    const {
      languages,
      currentPath,
      intl,
      locale,
      hideLocations,
      seoSearchUrlResponse: { make, trends, locations: seoLocations, location: selectedLocation },
    } = this.props;

    const socialLinks = [
      { icon: 'twitter', link: 'https://twitter.com/avtobazar' },
      { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' },
      { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' },
      { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' },
    ];
    const allLocations = getAllLocations().map(setActiveLocations(seoLocations, selectedLocation));
    const cities = allLocations.filter(item => item.is_admin_center).sort(compareByTitle);
    const regions = allLocations.filter(item => item.is_region).sort(compareByTitle);

    const hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
    const hideRegLocations = hideRegLocValues.some(item => currentPath.includes(item));

    let formattedTrends = [];
    if (trends) {
      formattedTrends = trends
        .map((a, b) => ({
          id: b,
          slug: '',
          title: a[`title_${intl.locale}`],
          hint: a[`text_${intl.locale}`],
          url: a.url,
        }))
        .filter((a, b) => b < 30);
    }
    const titleKey = locale === 'uk' ? 'uk_title' : 'title';

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.flexContainer}>
            <div className={s.left}>
              <ul className={s.nav}>
                {LINKS.FOOTER.map(item => (
                  <li key={item.title}>
                    <Link className={s.link} to={item.route} rel="nofollow">
                      <FormattedMessage id={item.title} />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className={s.right}>
              <span className={s.tel}>+380 44 206-56-06</span>
              <div>
                {languages.map(item => (
                  <span className={s.lang} key={item.slug}>
                    {locale === item.slug ? (
                      <span>{item.title}</span>
                    ) : (
                      <a
                        href={toLocalized(removeLocaleFromHref(currentPath), item.slug)}
                        data-lang-code={item.slug}
                      >
                        {item.title}
                      </a>
                    )}
                  </span>
                ))}
              </div>
            </div>
          </div>
          {trends && trends[0] ? (
            <React.Fragment>
              <hr className={s.divide} style={{ margin: '8px 0 8px 0' }} />
              <LocationList countries={undefined} cities={formattedTrends} search />
            </React.Fragment>
          ) : (
            ''
          )}
          {!hideLocations && <hr className={s.divide} style={{ margin: '8px 0 0px 0' }} />}
          {!hideRegLocations && !hideLocations && (
            <LocationList
              cities={regions}
              search={false}
              selectedLocation={selectedLocation}
              isRegion
              titleKey={titleKey}
            />
          )}
          {!hideLocations && (
            <LocationList
              cities={cities}
              search={false}
              selectedLocation={selectedLocation}
              titleKey={titleKey}
              isRegion={hideRegLocations}
            />
          )}
          <hr className={s.divide} />
          <div className={s.flexContainer}>
            <div className={s.left}>
              <ul className={s.nav}>
                <li>
                  <Link className={s.smallLink} to="/law/" rel="nofollow">
                    <FormattedMessage id="Политика конфиденциальности" />
                  </Link>
                </li>
                <li>
                  <Link className={s.smallLink} to="/advertising-conditions/" rel="nofollow">
                    <FormattedMessage id="Правила публикации объявлений" />
                  </Link>
                </li>
                <li>
                  <Link className={s.smallLink} to="/public-contract/" rel="nofollow">
                    <FormattedMessage id="Публичный договор" />
                  </Link>
                </li>
              </ul>
            </div>
            <div className={s.right}>
              <a href="mailto:support@ab.ua" className={s.tel} rel="nofollow">
                support@ab.ua
              </a>
              <SocialLinks socialLinks={socialLinks} />
            </div>
          </div>
        </div>
        <div className={s.footerCopyRight}>
          <p>
            © {new Date().getFullYear()}&nbsp;
            <Link className={s.smallLink} to="/">
              <FormattedMessage id="Автобазар™" />
            </Link>
            <FormattedMessage id="– Купить новое авто или продать бу с пробегом в Украине" />
          </p>
        </div>
      </div>
    );
  }
}

function SocialLinks({ socialLinks }) {
  return (
    <div>
      {socialLinks.map(({ link, icon }) => (
        <a
          href={link}
          target="_blank"
          rel="nofollow noopener noreferrer"
          key={icon}
          className={s.socialLink}
        >
          <i className={`fa fa-${icon}`} />
        </a>
      ))}
    </div>
  );
}
SocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      link: PropTypes.string,
    }),
  ).isRequired,
};

const mapStateToProps = ({ history, searchForm, globals }) => ({
  currentPath: history.currentPath,
  routeName: history && history.currentRouteName,
  countries: COUNTRIES,
  formState: searchForm && searchForm.selected,
  seoSearchUrlResponse: globals.seoSearchUrlResponse,
  locale: globals.locale,
});

export default withStyles(s)(connect(mapStateToProps)(injectIntl(Footer)));



// WEBPACK FOOTER //
// ./src/desktop/components/Footer/Footer.js